import * as React from "react";
import type { SVGProps } from "react";

interface BullyProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Bully = ({ cancelled = false, ...props }: BullyProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(.75 .75)">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.25 0C5.037 0 0 5.037 0 11.25S5.037 22.5 11.25 22.5 22.5 17.463 22.5 11.25 17.463 0 11.25 0"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M11.25.95C5.561.95.95 5.561.95 11.25s4.611 10.3 10.3 10.3 10.3-4.611 10.3-10.3S16.939.95 11.25.95m0 1.3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
      />
      <circle cx={11.25} cy={11.25} r={5} fill="#FF1212" />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Bully;
